import React from 'react'

const SendToL2ApprovalModalUI = ({ title, onSubmitClick, onCancelClick, children, submitting }) => {
  return (
    <div className="modal-backdrop" style={backdropStyle}>
      <div className="modal-content" style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>{title}</h3>
        <div>{children}</div>
        <div style={{ marginTop: '20px', textAlign: 'right' }}>
          <button
            onClick={onCancelClick}
            disabled={submitting}
            style={buttonStyle}
          >
            Close this tab
          </button>
          <button
            onClick={onSubmitClick}
            disabled={submitting}
            style={{ ...buttonStyle, ...submitButtonStyle }}
          >
            {submitting ? 'Submitting...' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  )
}

// Inline styles for the modal
const backdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}

const modalStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  minWidth: '400px',
  maxWidth: '500px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
}

const buttonStyle = {
  padding: '8px 16px',
  fontSize: '14px',
  cursor: 'pointer',
  border: '1px solid #ddd',
  borderRadius: '4px',
  backgroundColor: '#fff'
}

const submitButtonStyle = {
  marginLeft: '10px',
  backgroundColor: '#007bff',
  color: 'white',
  border: '1px solid #007bff'
}

export default SendToL2ApprovalModalUI